/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { useTheme } from '@/hooks/useTheme';
import { Text } from '@/primitives/Text';

import './MoreSubtenantsPlaceholder.css';

export function MoreSubtenantsPlaceholder() {
  const { t } = useMimicTranslation('subtenants');
  const theme = useTheme();

  const color = { color: theme.antdComponents?.Menu?.itemColor };

  return (
    <div
      style={{
        display: 'flex',
        gap: 10,
        padding: '10px 0',
        borderTop: `1px solid ${theme.tokens.color.border.borderDeeper}`,
      }}
      data-testid="more-subtenants-placeholder"
    >
      <div style={{ flexGrow: 1, display: 'flex', gap: 10, overflow: 'hidden', maxWidth: '165px' }}>
        <Text data-testid="subtenant-name" style={color} ellipsis>
          {t('searchForMore')}
        </Text>
      </div>
    </div>
  );
}
